"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../../../index");

var _ChangeRequestsModel = _interopRequireDefault(require("../../../models/ChangeRequestsModel"));

var _ModalDialog = _interopRequireDefault(require("../../../../../../components/modal/ModalDialog"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ChangeRequests = /*#__PURE__*/function (_Component) {
  _inherits(ChangeRequests, _Component);

  function ChangeRequests(props) {
    var _this;

    _classCallCheck(this, ChangeRequests);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChangeRequests).call(this, props));
    _this.state = {
      requests: [],
      showModal: false
    };
    return _this;
  }

  _createClass(ChangeRequests, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var id = this.props.user.id;

      if (id) {
        new _ChangeRequestsModel["default"]().geRequestChanges(id).then(function (result) {
          _this2.setState({
            requests: result.items
          });
        });
      }
    } // approveUserRequest(id) {
    //   if (id) {
    //     (new ChangeRequestsModel().approveRequest(id))
    //   }
    // }

  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "onAproveUser",
    value: function onAproveUser(id) {
      var _this3 = this;

      new _ChangeRequestsModel["default"]().approveRequest(id).then(function () {
        _this3._tableComponent._refresh();
      })["catch"](function () {// this.setState({
        //   showInfoModal: true
        // })
      });
    }
  }, {
    key: "onRejectUserRequest",
    value: function onRejectUserRequest(id) {
      var _this4 = this;

      new _ChangeRequestsModel["default"]().rejectRequest(id).then(function () {
        _this4._tableComponent._refresh();
      })["catch"](function () {// this.setState({
        //   showInfoModal: true
        // })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var user = this.props.user; // let items =  this._renderRequests();
      // let items = this.renderRequests();

      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement(_index.AppTable, {
        title: "Change Requests",
        onInit: function onInit(tableComponent) {
          return _this5._tableComponent = tableComponent;
        },
        parseUrl: false // headerActions={<Link to="/users/all-users/add-new" className="button width-240" style={{ marginRight: '10px' }}><i className="fa fa-fw fa-plus"></i>Add new</Link>}
        ,
        filter: [{
          name: 'term',
          type: 'term'
        }],
        params: {
          user: user.id
        },
        model: _ChangeRequestsModel["default"],
        getColumnActions: function getColumnActions(item, index) {
          return _react["default"].createElement("div", null, _react["default"].createElement("button", {
            onClick: function onClick() {
              return _this5.openModal();
            },
            className: "button-info"
          }, "Details"), _react["default"].createElement("button", {
            onClick: function onClick() {
              return _this5.onAproveUser(item.id);
            },
            className: "button-info"
          }, "Approve"), _react["default"].createElement("button", {
            onClick: function onClick() {
              return _this5.onRejectUserRequest(item.id);
            },
            className: "button-info"
          }, "Reject"));
        }
      }), _react["default"].createElement(_ModalDialog["default"], {
        show: this.state.showModal,
        onClose: this.closeModal.bind(this),
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true
      }, _react["default"].createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, "Detailed Info"), _react["default"].createElement("hr", null), _react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, _react["default"].createElement("p", null, user.title), _react["default"].createElement("p", null, user.fullName), _react["default"].createElement("p", null, user.mobile), _react["default"].createElement("p", null, user.country ? user.country.name : '-'), _react["default"].createElement("p", null, user.city), _react["default"].createElement("p", null, user.addressOne), _react["default"].createElement("p", null, user.postcode)))));
    }
  }]);

  return ChangeRequests;
}(_react.Component);

exports["default"] = ChangeRequests;